import img01 from "../assets/images/feature/img-01.png";
import img02 from "../assets/images/feature/img-02.png";
import img03 from "../assets/images/feature/img-03.png";
import img04 from "../assets/images/feature/img-04.png";
import img05 from "../assets/images/feature/img-05.png";
import img06 from "../assets/images/feature/img-06.png";
import img07 from "../assets/images/feature/img-07.png";
import img08 from "../assets/images/feature/img-08.png";
import img09 from "../assets/images/feature/img-09.svg";

export const servicesData = [
  {
    slug: "modern-data-platforms",
    imgsrc: img01,
    title: "Modern Data Platforms",
    caption:
      "We design and build modern data platforms for SAP customers using SAP Datasphere, SAP Business Data Cloud (BDC), and leading cloud technologies including AWS, Azure, Snowflake, and Databricks. Our solutions integrate SAP and non SAP data into scalable, governed platforms supporting analytics and AI.",
    overview:
      "Citra helps SAP customers design, build, and operationalise modern data platforms that bring SAP and non SAP data together for trusted analytics, AI, and enterprise decision making.",
    highlights: [
      {
        title: "Platform architecture",
        description:
          "Define target architectures across SAP Datasphere, SAP Business Data Cloud, hyperscalers, and best of breed data platforms.",
      },
      {
        title: "Data integration",
        description:
          "Connect SAP and non SAP data into governed, reusable data products that support reporting, analytics, and AI workloads.",
      },
      {
        title: "Delivery acceleration",
        description:
          "Move from roadmap to working platform with pragmatic patterns, delivery governance, and implementation support.",
      },
    ],
    outcomes: [
      "A scalable architecture for SAP and cloud data",
      "Clear governance for trusted data products",
      "Foundations that support analytics, AI, and future platform growth",
    ],
    engagements: [
      "Architecture and roadmap assessment",
      "Data platform MVP or pilot",
      "Platform build, migration, and optimisation",
    ],
    contact: {
      enquiry: "modern-data-platforms",
      title: "Plan Your Modern Data Platform",
      description:
        "Tell us where your SAP and cloud data landscape is heading, and we will help shape a practical path from current state to scalable platform delivery.",
      messagePlaceholder:
        "Share the SAP and cloud data platforms you want to modernise.",
      submitLabel: "Talk Data Strategy",
    },
  },
  {
    slug: "analytics",
    imgsrc: img02,
    title: "Analytics",
    caption:
      "We deliver analytics and insight solutions using SAP Analytics Cloud and best of breed BI tools, enabling business users to access trusted, business ready insights. Our focus is on semantic modelling, performance, and usability, ensuring analytics solutions support informed decision making across SAP and cloud data platforms.",
    overview:
      "We help teams turn SAP and cloud data into trusted, usable analytics that business users can rely on for planning, performance management, and operational insight.",
    highlights: [
      {
        title: "Semantic modelling",
        description:
          "Create business-ready models and metrics that make complex SAP data easier to understand, govern, and reuse.",
      },
      {
        title: "Analytics delivery",
        description:
          "Design dashboards, planning views, and reporting experiences in SAP Analytics Cloud and complementary BI tools.",
      },
      {
        title: "Performance and adoption",
        description:
          "Improve usability, performance, and confidence so analytics becomes part of day to day decision making.",
      },
    ],
    outcomes: [
      "Trusted insights across SAP and cloud data",
      "Better self service for business users",
      "Analytics solutions designed for performance and adoption",
    ],
    engagements: [
      "Analytics strategy and solution design",
      "SAP Analytics Cloud build or uplift",
      "Dashboard, planning, and semantic model delivery",
    ],
    contact: {
      enquiry: "analytics",
      title: "Improve Your Analytics Experience",
      description:
        "Share the reporting or planning challenge you want to solve, and we will help identify the right analytics approach.",
      messagePlaceholder:
        "Tell us about the analytics, dashboards, or planning processes you want to improve.",
      submitLabel: "Discuss Analytics",
    },
    isShadow: true,
  },
  {
    slug: "custom-applications-service-layer-cloud-solutions",
    imgsrc: img05,
    title: "Custom Applications, Service Layer & Cloud Solutions",
    caption:
      "We design and build custom SAP BTP applications using CAP, SAPUI5, node.js, React and cloud native services. Our solutions include secure service layers, business applications, and SAP extensions that integrate seamlessly with core systems while supporting scalability, maintainability, and future platform evolution",
    overview:
      "Citra builds secure SAP BTP applications, service layers, and cloud native solutions that extend core SAP systems without creating fragile custom code.",
    highlights: [
      {
        title: "BTP application delivery",
        description:
          "Build applications using CAP, SAPUI5, Node.js, React, and SAP BTP services aligned to enterprise architecture standards.",
      },
      {
        title: "Service layer design",
        description:
          "Create secure APIs and services that expose core processes and data while protecting maintainability.",
      },
      {
        title: "Cloud native extension",
        description:
          "Extend SAP landscapes with scalable applications that integrate cleanly with SAP and cloud services.",
      },
    ],
    outcomes: [
      "Practical applications that improve business workflows",
      "Secure services that reduce point to point complexity",
      "Cloud solutions built for long term maintainability",
    ],
    engagements: [
      "Solution discovery and prototype",
      "SAP BTP application build",
      "Service layer and extension architecture",
    ],
    contact: {
      enquiry: "custom-applications-service-layer-cloud-solutions",
      title: "Build The Right SAP BTP Application",
      description:
        "Tell us what process, extension, or service layer you need, and we will help turn it into a buildable SAP BTP solution.",
      messagePlaceholder:
        "Describe the application, service, or SAP extension you want to create.",
      submitLabel: "Start App Discovery",
    },
    isShadow: true,
  },
  {
    slug: "integration-event-driven-architecture",
    imgsrc: img03,
    title: "Integration & Event Driven Architecture",
    caption:
      "We design secure, scalable integration architectures on SAP BTP using SAP Integration Suite, APIs, and event driven patterns. Our solutions connect SAP and non SAP systems across hybrid and multi cloud landscapes, enabling real time data exchange, extensibility, and resilient system to system communication.",
    overview:
      "We help organisations modernise integration across SAP and non SAP systems using SAP Integration Suite, APIs, event driven patterns, and resilient operating models.",
    highlights: [
      {
        title: "Integration architecture",
        description:
          "Define integration patterns, API standards, security models, and governance for SAP and hybrid landscapes.",
      },
      {
        title: "SAP Integration Suite",
        description:
          "Design and deliver integrations using Cloud Integration, API Management, Event Mesh, and related SAP BTP services.",
      },
      {
        title: "Event driven design",
        description:
          "Introduce event based patterns that support real time data exchange, extensibility, and resilient communication.",
      },
    ],
    outcomes: [
      "Cleaner integration patterns across SAP and cloud systems",
      "Reduced point to point complexity",
      "More responsive data and process exchange",
    ],
    engagements: [
      "Integration modernisation assessment",
      "SAP Integration Suite implementation",
      "API and event driven architecture design",
    ],
    contact: {
      enquiry: "integration-event-driven-architecture",
      title: "Modernise Your SAP Integrations",
      description:
        "Share the systems and integration challenges in your landscape, and we will help define a secure, scalable architecture.",
      messagePlaceholder:
        "Tell us about the SAP, cloud, and third party systems you need to connect.",
      submitLabel: "Discuss Integration",
    },
  },
  {
    slug: "sap-support-cloud-alm-services",
    imgsrc: img09,
    title: "SAP Support & Cloud ALM Services",
    caption:
      "We provide SAP BTP support and Cloud ALM services to keep applications, integrations, and platform services running reliably. Our team manages incidents, enhancements, monitoring, release coordination, and operational governance, helping customers improve service quality while maintaining clear visibility across hybrid SAP landscapes.",
    overview:
      "Keep SAP BTP applications, integrations, and platform services reliable with proactive support, SAP Cloud ALM monitoring, incident management, controlled releases, and operational governance.",
    campaignCallout: {
      title: "Need A Stronger SAP BTP Support Model?",
      description:
        "If your team has moved important workloads onto SAP BTP, now is the time to put the right support, monitoring, and Cloud ALM foundations in place. Book a short support assessment and we will help identify the gaps, risks, and quick wins.",
    },
    highlights: [
      {
        title: "Operational support",
        description:
          "Provide responsive support for SAP BTP applications, integrations, platform services, incidents, and enhancements.",
      },
      {
        title: "Cloud ALM setup",
        description:
          "Configure SAP Cloud ALM for monitoring, operations, health visibility, release coordination, and service management.",
      },
      {
        title: "Support governance",
        description:
          "Establish clear ownership, triage, escalation, release, and improvement rhythms across hybrid SAP landscapes.",
      },
    ],
    outcomes: [
      "Faster incident triage and clearer ownership",
      "Better visibility across applications, integrations, and platform services",
      "A practical support model that improves service quality over time",
    ],
    engagements: [
      "SAP BTP support assessment",
      "SAP Cloud ALM implementation or uplift",
      "Managed support and continuous improvement",
    ],
    contact: {
      enquiry: "sap-support-cloud-alm-services",
      title: "Book A SAP BTP Support Assessment",
      description:
        "Tell us what you support today, where the pain points are, and we will help shape a clear SAP BTP and Cloud ALM support plan.",
      messagePlaceholder:
        "Share your SAP BTP support, monitoring, or Cloud ALM challenge.",
      submitLabel: "Book Support Assessment",
    },
    isCampaign: true,
    isShadow: true,
  },
  {
    slug: "agentic-generative-ai",
    imgsrc: img04,
    title: "Agentic and Generative AI",
    caption:
      "We design and build AI Agents and Gen AI solutions that leverage data from SAP and cloud platforms to enhance analytics and operational processes. Our Agents and models are designed for real world deployment, integrating into SAP BTP architectures to deliver actionable insights and intelligent, data driven capabilities.",
    overview:
      "We design and build practical agentic and generative AI solutions that use SAP and cloud data responsibly to improve analytics, decisions, and operational processes.",
    highlights: [
      {
        title: "AI use case discovery",
        description:
          "Identify high value use cases where agents, copilots, or Gen AI capabilities can solve real business problems.",
      },
      {
        title: "Data and architecture",
        description:
          "Connect AI solutions to trusted SAP and cloud data using secure, governed, enterprise-ready patterns.",
      },
      {
        title: "Production deployment",
        description:
          "Move beyond demos with controls, monitoring, integration, and adoption plans suited to real operations.",
      },
    ],
    outcomes: [
      "AI use cases tied to measurable business value",
      "Secure access to trusted SAP and cloud data",
      "Agentic capabilities designed for real world deployment",
    ],
    engagements: [
      "AI opportunity assessment",
      "Prototype or proof of value",
      "Agentic AI solution design and build",
    ],
    contact: {
      enquiry: "agentic-generative-ai",
      title: "Explore Practical AI For SAP",
      description:
        "Tell us where AI could improve a decision, workflow, or analytics process, and we will help assess the right architecture.",
      messagePlaceholder:
        "Describe the SAP or cloud data process you want AI to support.",
      submitLabel: "Explore AI Options",
    },
    isShadow: true,
  },
  {
    slug: "strategy-architecture-governance",
    imgsrc: img06,
    title: "Strategy, Architecture & Governance",
    caption:
      "We provide strategy, architecture, and governance services to support successful SAP BTP and data platform adoption. Our approach covers platform design, operating models, security, and standards, ensuring solutions are scalable, maintainable, and aligned with business objectives and enterprise architecture principles.",
    overview:
      "Citra helps organisations make confident platform decisions by aligning SAP BTP, data, integration, security, and operating models with business and enterprise architecture priorities.",
    highlights: [
      {
        title: "Platform strategy",
        description:
          "Define target states, roadmaps, priorities, and investment options for SAP BTP and modern data platforms.",
      },
      {
        title: "Architecture standards",
        description:
          "Set pragmatic design guardrails for security, integration, extensibility, data, operations, and maintainability.",
      },
      {
        title: "Governance and operating model",
        description:
          "Create decision forums, delivery controls, ownership models, and quality practices that support sustainable adoption.",
      },
    ],
    outcomes: [
      "A clearer SAP BTP and platform roadmap",
      "Architecture principles that guide delivery",
      "Governance that supports speed without losing control",
    ],
    engagements: [
      "Architecture review or health check",
      "SAP BTP strategy and roadmap",
      "Governance and operating model design",
    ],
    contact: {
      enquiry: "strategy-architecture-governance",
      title: "Shape Your SAP BTP Roadmap",
      description:
        "Share the decisions you are working through, and we will help define a practical strategy, architecture, and governance approach.",
      messagePlaceholder:
        "Tell us about the SAP BTP, data, or architecture decisions ahead.",
      submitLabel: "Plan The Roadmap",
    },
    isShadow: true,
  },
  {
    slug: "s4hana-erp-transformation",
    imgsrc: img07,
    title: "S/4HANA & ERP Transformation",
    caption:
      "We guide organisations through S/4HANA migrations and broader ERP transformation initiatives. From strategy and roadmap design through implementation governance, data readiness, and post go live optimisation, we provide independent expertise to ensure programs deliver measurable business outcomes, not just technical upgrades.",
    overview:
      "We support S/4HANA and ERP transformation programs with independent advice, delivery governance, data readiness, and practical focus on measurable business outcomes.",
    highlights: [
      {
        title: "Transformation strategy",
        description:
          "Shape the roadmap, scope, business case, and delivery approach for S/4HANA and broader ERP change.",
      },
      {
        title: "Program governance",
        description:
          "Support delivery controls, decision making, risk management, and quality practices across major ERP initiatives.",
      },
      {
        title: "Data and readiness",
        description:
          "Prepare data, processes, teams, and post go live support models for a smoother transition.",
      },
    ],
    outcomes: [
      "A transformation roadmap tied to business value",
      "Stronger delivery governance and risk management",
      "Readiness across data, process, and operating model",
    ],
    engagements: [
      "S/4HANA roadmap and options assessment",
      "Transformation governance support",
      "Data readiness and post go live optimisation",
    ],
    contact: {
      enquiry: "s4hana-erp-transformation",
      title: "Prepare For ERP Transformation",
      description:
        "Tell us where you are in your S/4HANA or ERP journey, and we will help identify the next practical steps.",
      messagePlaceholder:
        "Share your S/4HANA, migration, or ERP transformation challenge.",
      submitLabel: "Discuss Transformation",
    },
    isShadow: true,
  },
  {
    slug: "erp-advisory-program-assurance",
    imgsrc: img08,
    title: "ERP Advisory & Program Assurance",
    caption:
      "We provide independent ERP advisory services, including program governance, portfolio management, internal QA, and functional leadership. Acting as a bridge between business stakeholders and system integrators, we protect delivery quality, manage risk, and ensure enterprise transformation programs remain aligned to strategic objectives.",
    overview:
      "Citra provides independent ERP advisory and program assurance to help business stakeholders, delivery teams, and system integrators stay aligned around quality, risk, and outcomes.",
    highlights: [
      {
        title: "Independent assurance",
        description:
          "Review program health, delivery quality, risks, dependencies, and readiness from an independent perspective.",
      },
      {
        title: "Functional leadership",
        description:
          "Bridge business needs and system integrator delivery through pragmatic functional and architectural leadership.",
      },
      {
        title: "Portfolio governance",
        description:
          "Support portfolio priorities, delivery cadence, internal QA, and decision making across transformation programs.",
      },
    ],
    outcomes: [
      "Clearer visibility of delivery risk and quality",
      "Better alignment between business and delivery teams",
      "Stronger governance for complex ERP programs",
    ],
    engagements: [
      "Program health check",
      "Independent QA and assurance",
      "ERP advisory and functional leadership",
    ],
    contact: {
      enquiry: "erp-advisory-program-assurance",
      title: "Get Independent ERP Assurance",
      description:
        "Tell us where the program risk or uncertainty sits, and we will help bring independent structure and clarity.",
      messagePlaceholder:
        "Describe the ERP program, delivery risk, or assurance support you need.",
      submitLabel: "Request Assurance",
    },
    isShadow: true,
  },
];

export const getServiceBySlug = (slug) =>
  servicesData.find((service) => service.slug === slug);
